import { useState, useCallback, ReactNode } from 'react';
import Modal from 'antd/lib/modal';
// eslint-disable-next-line no-restricted-imports
import { useTranslation } from 'react-i18next';

type OkButtonType =
  | 'primary'
  | 'dashed'
  | 'link'
  | 'text'
  | 'default'
  | 'danger';

interface ConfirmModalProps {
  shown: boolean;
  hide: () => void;
  modal: {
    action?: () => Promise<void> | void;
    title?: ReactNode;
    ok?: ReactNode;
    content: ReactNode;
  };
  okButtonType?: OkButtonType;
}

export default function ConfirmModal({
  modal,
  shown,
  hide,
  okButtonType = 'danger'
}: ConfirmModalProps) {
  const { t } = useTranslation('confirmModal');
  const [inProcess, setInProcess] = useState(false);
  const handleOk = useCallback(async () => {
    setInProcess(true);
    await modal.action?.();
    setInProcess(false);
  }, [modal]);

  return (
    <Modal
      title={modal.title}
      visible={shown}
      onOk={modal.action ? handleOk : undefined}
      onCancel={hide}
      okText={modal.ok}
      confirmLoading={inProcess}
      cancelText={t('cancel')}
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      okButtonProps={{ type: okButtonType, disabled: !modal.action }}
    >
      {modal.content}
    </Modal>
  );
}
